"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const reducerFn = (prevState, action) => {
    const { type, payload } = action;
    if (type === 'ATUALIZAR_DADOS_AUTENTICACAO') {
        const { pessoa, organizacao, usuarioFirebase, autenticacaoLoading, necessarioAceitarTermos, } = payload;
        return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, prevState), (pessoa !== undefined && { pessoa })), (organizacao !== undefined && { organizacao })), (usuarioFirebase !== undefined && { usuarioFirebase })), (autenticacaoLoading !== undefined && {
            autenticacaoLoading: !!autenticacaoLoading,
        })), (necessarioAceitarTermos !== undefined && {
            necessarioAceitarTermos: !!necessarioAceitarTermos,
        }));
    }
    return prevState;
};
exports.default = reducerFn;
//# sourceMappingURL=reducer.js.map